import AES from 'crypto-js/aes'
import UTF8 from 'crypto-js/enc-utf8'
import SHA1 from 'crypto-js/sha1'
import {sha256} from 'js-sha256'

const keyMap: Record<string, string> = {}

const createKey = (key: string) => {
    if (!keyMap[key]) {
        keyMap[key] = SHA1(key).toString()
    }
    return keyMap[key]
}

const encrypt = <T extends object | string>(key: string, data: T): string => {
    return AES.encrypt(JSON.stringify(data), createKey(key)).toString()
}

const decrypt = <T extends object | string>(key: string, data: string): T => {
    return JSON.parse(AES.decrypt(data, createKey(key)).toString(UTF8))
}
export const getSha256 = (key: string) => {
    return sha256(key)
}
export default {
    createKey,
    encrypt,
    decrypt,
}
